import { THeaderType } from 'components/Header/Header'
import LinkWithLocale from 'components/LinkWithLocale'
import React, { FC } from 'react'
// import BadgeWarning from 'ui/Badge'
import arrowRightDropdownItem from 'assets/svg/arrowRightDropdownItem.svg'
import useTranslation from 'hooks/useTranslation'
import { TFunction } from 'src/providers/TranslateProvider/TranslateProvider'
import { BadgeType } from 'src/types'
import styled from 'styled-components'
import BadgeDropdown from '../BadgeDropdown'

const getOptions = (t: TFunction) => [
  {
    name: t('Convert crypto'),
    text: t('The easiest way to trade crypto'),
    url: '',
    badgeType: BadgeType.Soon,
  },
  {
    name: t('Spot trading'),
    text: t('Trade crypto on a spot exchange'),
    url: '',
    badgeType: BadgeType.InDevelopment,
  },
]

interface DropdownSpotProps extends IOwnProps {
  dropdownType:
    | 'app'
    | 'buy crypto'
    | 'futures'
    | 'spot'
    | 'explore trading'
    | 'price alerts'
    | 'staking'
    | 'markets'
    | 'refferal'
}

const DropdownSpot: FC<DropdownSpotProps> = () => {
  const { t } = useTranslation()

  return (
    <DropdownItemGridContainer>
      <ItemWrapper>
        {getOptions(t).map((item, index) => {
          const withLocale = item.url !== '/crypto-alerts'
          return (
            <DropdownItem key={index} to={item.url} withLocale={withLocale} replace>
              <NameWrapper>
                <DropdownItemName>{item.name}</DropdownItemName>
                <BadgeDropdown type={item.badgeType} />
              </NameWrapper>
              <DropdownItemText>{item.text}</DropdownItemText>
            </DropdownItem>
          )
        })}
      </ItemWrapper>
    </DropdownItemGridContainer>
  )
}

export default DropdownSpot

// const DropdownContainer = styled.div`
//   position: relative;
//   -webkit-tap-highlight-color: transparent;
// `

// const NameContainer = styled.div<{ $type: THeaderType; $dropdownType?: DropdownSpotProps }>`
//   display: flex;
//   align-items: center;
//   color: ${({ theme: { colors }, $type }) => ($type === 'secondary' ? colors.white : colors.newLightColor.paleWhite)};
//   font-weight: 600;
//   font-size: 14px;

//   &::after {
//     display: inline-block;
//     margin-inline-start: 6px;
//     vertical-align: 3.96px;
//     content: '';
//     width: 9px;
//     height: 6px;
//     border-style: solid;
//     border-width: 6px 5px 0 5px;
//     border-color: #6b7b9f transparent transparent transparent;
//   }
//   &:hover {
//     ::after {
//       transition: all 0.1s ease-out;
//       border-color: #00e0ff transparent transparent transparent;
//       transform: rotate(180deg);
//     }
//   }
// `

// const Dropdown = styled.div<{ $isActive?: boolean; $dropdownType?: DropdownSpotProps }>`
//   display: ${({ $isActive }) => ($isActive ? 'grid' : 'none')};
//   position: absolute;
//   top: 100%;
//   left: 50%;
//   right: 50%;
//   z-index: 10;
//   min-width: 10rem;
//   margin: 1.125rem 0 0;
//   font-size: ${({ theme: { fontSize } }) => fontSize.base};
//   color: ${({ theme: { colors } }) => colors.default};
//   text-align: left;
//   list-style: none;
//   background-clip: padding-box;
//   width: auto;

//   transform: translateX(-50%);
//   transition: opacity 0.4s, visibility 0.4s;
//   &::before {
//     content: '';
//     height: 20px;
//     top: -20px;
//     left: 0;
//     right: 0;
//     z-index: -1;
//     position: absolute;
//   }

//   @media ${({ theme }) => theme.device.lgMax} {
//     left: 5%;

//     &::after {
//       left: 55%;
//     }
//   }
// `

const DropdownItemGridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 0.875rem;
  column-gap: 2.75rem;
  background: linear-gradient(0deg, #f3f7fd, #f3f7fd), #123482;
  /* box-shadow: 0px 15px 50px rgba(15, 42, 102, 0.7); */
  border-radius: 0.5rem;
`

// const BadgeWarningWrapper = styled(BadgeWarning)`
//   margin-inline-start: 0.5em;
// `
const ItemWrapper = styled.div`
  display: grid;
  grid-template-rows: max-content;
  grid-auto-rows: max-content;
  grid-column-gap: 3rem;
  grid-row-gap: 0.875rem;
  padding: 2rem;
`

const DropdownItem = styled(LinkWithLocale)`
  display: block;
  position: relative;
  padding: 0.625rem 0.75rem;
  clear: both;
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.normal};
  color: ${({ theme: { colors } }) => colors.dropdownItem};
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  text-align: start;
  border: 0;
  line-height: 1.375;
  transition: color 0.2s, background-color 0.2s;
  /* &:hover {
    > span {
      color: ${({ theme: { colors } }) => colors.link};
    }
    text-decoration: none;
    background-color: ${({ theme: { colors } }) => colors.white};
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 2rem;
      border-radius: 0.25rem;
      background-image: url(${arrowRightDropdownItem});
      background-repeat: no-repeat;
      background-position: center;
      background-color: ${({ theme: { colors } }) => colors.newLightColor.vividBlue};
    }
  } */
`
const DropdownItemName = styled.span`
  color: ${({ theme: { colors } }) => colors.newLightColor.softNavy};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.semibold};
  font-size: 0.875rem;
  margin-inline-end: 0.5rem;
`
const DropdownItemText = styled.p`
  width: 190px;
  margin: 0;
  margin-top: 2px;
  margin-inline-end: auto;
  white-space: pre-wrap;
  color: ${({ theme: { colors } }) => colors.newLightColor.softNavy};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.normal};
  font-size: 0.875rem;
  opacity: 0.8;
`
const NameWrapper = styled.div`
  align-items: center;
  min-width: 216px;
  text-align: start;
`

interface IOwnProps {
  name?: string
  options: Array<{ name: string; url: string }>
  warning?: string | null
  type: THeaderType
}
